import { render, staticRenderFns } from "./fccListaRelatorios.vue?vue&type=template&id=78ef232a"
import script from "./fccListaRelatorios.vue?vue&type=script&lang=js"
export * from "./fccListaRelatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports